import CounterControl from './CounterControl';

export default CounterControl;
